// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__WOZiz","content":"ManualTimeModal_content__1YTyN"};